import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { mergeMap, map, catchError, of } from "rxjs";
import { obterUltimaEdicaoECalendario, obterUltimaEdicaoECalendarioSuccess } from "../../actions/Jornal/obter-ultima-edicao-e-calendario-para-home.action";
import { JornalService } from "src/app/services/jornal.service";

@Injectable()
export class ObterUltimaEdicaoECalendarioEffects {

  public obterUltimaEdicaoECalendario$: unknown;

  constructor(private actions$: Actions,
    private obterJornaisCalendariosHomeService: JornalService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterUltimaEdicaoECalendario$ = createEffect(() => this.actions$.pipe(
      ofType(obterUltimaEdicaoECalendario),
      mergeMap(() =>
        this.obterJornaisCalendariosHomeService.ObterUltimaEdicaoECalendario()
        .pipe(map(response => {
          return obterUltimaEdicaoECalendarioSuccess({ response });
        }),
          catchError(() => of())
        )
      )
    )
    );
  }
}
